import React from 'react';
import { Toast } from 'antd-mobile';
import styles from './index.module.scss';
import selectImg from '../../assets/select.png';
import selectActive from '../../assets/selectA.png';
import ModalPopup from '../ModalPopup';
import md5 from 'blueimp-md5';
import { trackAddEmailInfo, trackInitiateCheckout, trackCheckoutPage, trackPurchase } from '../../utils/analytics';
import {
  trackPageView,
  trackPageProgress,
  trackClickCTA,
  trackViewContent,
  trackCompleteRegistration,
  trackInitiateCheckoutFB
} from '@/utils/analytics';

const CustomPopup = ({ visible, onClose }) => {
  const [email, setEmail] = React.useState('');
  const [selected, setSelected] = React.useState(false);
  const emailReg = /^[\w-.]+@[\w-]+\.[a-zA-Z]{2,}$/;
  const isEmailValid = emailReg.test(email.trim());
  const isBtnActive = isEmailValid && selected;
  const handleSelect = () => setSelected((v) => !v);
  const handleInput = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    // 当邮箱格式有效时上报埋点
    const emailReg = /^[\w-.]+@[\w-]+\.[a-zA-Z]{2,}$/;
    if (emailReg.test(newEmail.trim())) {
      trackAddEmailInfo(newEmail);
      trackCompleteRegistration();
    }
  };

  const [paramsA, setParamsA] = React.useState('');
  const [signA, setSignA] = React.useState('');

  // 支付参数
  const channelId = 'QY202508';
  const key = '9866C9C668254E8E837EA94A1DD5CCA1';

  const orderAmount = '0.09';
  const goodsName = 'EBOOK';
  const detailInfo = 'EBOOK_FULL';
  const price = '0.09';
  const [userIPState, setUserIP] = React.useState('');
  let osType = 'OTHER';
  let frontUrl = '';
  if (typeof window !== 'undefined') {
    osType = window.navigator.platform.includes('Win')
      ? 'WINDOWS'
      : window.navigator.platform.includes('Mac')
      ? 'MAC'
      : 'OTHER';
    // frontUrl = window.location.origin + window.location.pathname + '?success=1';
    frontUrl = 'https://coolearn.fun/';
  }
  // 获取IP（可用第三方接口或后端注入）
  React.useEffect(() => {
    try {
      fetch('https://api.ipify.org?format=json')
        .then((res) => res.json())
        .then((data) => {
          if (data && data.ip) setUserIP(data.ip);
        });
    } catch (error) {}
  }, []);
  function getSign(params, key) {
    // 排序并拼接
    const keys = Object.keys(params).sort();
    let str = keys.map((k) => `${k}=${params[k]}`).join('&');
    str += `&key=${key}`;
    console.log('签名原始串:', str); // 调试输出
    return md5(str).toUpperCase();
  }

  function getOrderNum() {
    // 生成唯一订单号
    return 'goallpay_' + Date.now() + Math.floor(Math.random() * 100000);
  }

  const handleBuy = async () => {
    if (!isBtnActive) return;

    // 上报点击支付按钮埋点
    trackInitiateCheckout({
      value: orderAmount,
      currency: 'USD',
      email: email
    });

    // 存储 email 到 localStorage，供成功弹窗读取
    if (typeof window !== 'undefined') {
      localStorage.setItem('userEmail', email);
    }
    trackInitiateCheckoutFB();
    Toast.show({ icon: 'loading', content: 'Processing...', duration: 0 });
    const orderNum = getOrderNum();
    // 严格按文档参数，仅包含必需字段
    const params = {
      channelId,
      orderNum,
      orderAmount,
      frontUrl,
      goodsName,
      detailInfo,
      osType,
      userIP: userIPState || '0.0.0.0',
      userID: email,
      userEmail: email,
      price
    };
    // 签名时不含 sign 字段
    const sign = getSign(params, key);
    // postData加上sign
    const postData = { ...params, sign };
    setParamsA(JSON.stringify(postData));
    try {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', 'https://www.icashhk.com/v1/payments/goallpay/vmpay.aspx', true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4) {
          Toast.clear();
          if (xhr.status === 200) {
            try {
              const result = JSON.parse(xhr.responseText);
              if (result.code === '00' && result.busContent) {
                // 上报跳转到收银台埋点
                trackCheckoutPage();
                window.location.href = result.busContent;
              } else {
                Toast.show({ icon: 'fail', content: result.msg + paramsA || 'Payment failed' });
              }
            } catch (e) {
              Toast.show({ icon: 'fail', content: 'Response parse error' });
            }
          } else {
            Toast.show({ icon: 'fail', content: 'Network error' });
          }
        }
      };
      xhr.onerror = function () {
        Toast.clear();
        Toast.show({ icon: 'fail', content: 'Network error' });
      };
      xhr.send(JSON.stringify(postData));
    } catch (err) {
      Toast.clear();
      Toast.show({ icon: 'fail', content: 'Network error' });
    }
  };
  return (
    <ModalPopup visible={visible} onClose={onClose}>
      <div className={styles.app}>
        <div className={styles.top}>
          <div className={styles.title}>Get Your Full eBook Now!</div>
          <div className={styles.desc}>Enter your email address so we can deliver your PDF after purchase.</div>

          <div className={styles.emailTitle}>Email Address</div>
          <div className={styles.emailInput}>
            <input type="email" placeholder="user@example.com" value={email} onChange={handleInput} />
          </div>
          <div className={styles.select} onClick={handleSelect} style={{ cursor: 'pointer' }}>
            <img src={selected ? selectActive : selectImg} alt="" />I want to receive updates and bonus chapters.
          </div>
          <div className={styles.price}>
            Secure Checkout - <span>$0.09</span>
          </div>
          <div
            className={styles.btn}
            style={{
              opacity: isBtnActive ? 1 : 0.5,
              pointerEvents: isBtnActive ? 'auto' : 'none',
              cursor: isBtnActive ? 'pointer' : 'not-allowed'
            }}
            onClick={handleBuy}
          >
            Buy Now
          </div>
          <div className={styles.btnDesc}>Please enter a valid email to continue！</div>
        </div>
      </div>
    </ModalPopup>
  );
};

export default CustomPopup;
